import { OOCheckItem } from "./oo-check-item";

export class OOCheck {
	checkKey?: string;
	items: OOCheckItem[] = [];
	total?: number;
	subtotal?: number;
	remainingBalance: number;
	tax?: number;
	tip?: number;
	tipPercent?: number;
	verified?: boolean;
	customerKey?: number;
	checkNumber?: number;
	token?: string;
	orderType?: number;
	orderTypeFee?: number;
	creditCardPassAlongFee?: number;
	futureOrder = "now";
	futureOrderTime: string;
	status: number;
	newItems?: boolean;
	loyaltyPhone: string;
	loyaltyAccount: string;
	leadTime?: number;
	linkKey: string;
	creditCard?: {
		cardNumber?: number;
		cardExpirationMonth?: string;
		cardExpirationYear?: string;
		cardCvv?: number;
		displayName?: string;
		extendedCardData?: string;
	} = {};
	billing?: {
		firstName?: string;
		lastName?: string;
		phone?: string;
		email?: string;
		address1?: string;
		address2?: string;
		city?: string;
		state?: string;
		postalCode?: string;
		country?: string;
	} = {};
	shipping?: {
		firstName?: string;
		lastName?: string;
		phone?: string;
		email?: string;
		address1?: string;
		address2?: string;
		city?: string;
		state?: string;
		postalCode?: string;
		country?: string;
	} = {};
	meta: any = {};

	public constructor(init?: Partial<OOCheck>) {
		Object.assign(this, init);
	}
}
